<template>
  <div class="accordion-faq wow move-up">
    <div class="row">
      <div
        v-for="(item, key) in $props.items"
        :key="key"
        class="col-lg-6 col-md-12 p-10 mb-15"
      >
        <b-card no-body>
          <b-card-header header-tag="header">
            <b-button
              block
              v-b-toggle
              :href="`#accordion-${key}`"
              @click.prevent
              class="faq-title"
            >
              {{ item.title }}
            </b-button>
          </b-card-header>
          <b-collapse
            :id="`accordion-${key}`"
            visible
            :accordion="`faq-accordion`"
          >
            <b-card-body>
              <b-card-text>
                {{ item.description }}
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HAccordion",
  props: {
    items: {
      type: Array,
    },
  },
};
</script>
